import axios from 'axios';

export default {
    namespaced: true,
    state: { categories: [] },
    actions: {
        shop_category_list({ commit }, shopId) {
            return axios.get('shops/' + shopId + '/categories').then(r => {
                commit("SET", r.data.data.categories); return r;
            });
        },
        shop_category_create(_, { shopId, payload }) {
            return axios.post('shops/' + shopId + '/categories', payload);
        },
        shop_category_update(_, { shopId, id, payload }) {
            return axios.put('shops/' + shopId + '/categories/' + id, payload);
        },
        shop_category_delete(_, { shopId, id }) {
            return axios.delete('shops/' + shopId + '/categories/' + id);
        },
    },
    mutations: { SET(state, items) { state.categories = items; } },
};
